import { render } from "./PreschoolPerformanceByPeriodContent.vue?vue&type=template&id=78a38dbe&ts=true"
import script from "./PreschoolPerformanceByPeriodContent.vue?vue&type=script&lang=ts"
export * from "./PreschoolPerformanceByPeriodContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__